import { LOGGING } from '@/src/lib/core/config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function log(message?: any, ...optionalParams: Array<any>) {
  if (!LOGGING) return;

  if (typeof window !== 'undefined') {
    const { clientLogger } = await import('../client-logger');
    clientLogger(message, ...optionalParams);
  } else {
    const { serverLog } = await import('../server-logger');
    serverLog(message, ...optionalParams);
  }
}
